import { useEffect } from 'react'
import { apiService } from '@/service/api'

// Boards warmed in this page session. The server keeps a board's files ready once they are built, so one request per
// board is enough; reopening the chat panel or remounting it does not ask again.
const warmed = new Set<string>()

/**
 * Ask the server to get the board's agent ready as its chat opens: on a new tenant the first question otherwise
 * prepared every file on the board itself (2026-11-02, dev: 95 s of a 111 s first answer). Best effort: a failure
 * only means the first question prepares, as before.
 */
export function useWarmBoardAgent(boardId: string | undefined): void {
  useEffect(() => {
    if (!boardId || warmed.has(boardId)) return
    warmed.add(boardId)
    apiService.prepareBoardAgent(boardId).catch((err: unknown) => {
      warmed.delete(boardId) // try again the next time the chat opens
      console.warn('[BoardChat] Agent warm-up failed:', err)
    })
  }, [boardId])
}

/** Tests only: forget which boards were warmed. */
export function __resetWarmedBoardsForTests(): void {
  warmed.clear()
}
